import React from 'react'

import Select from 'react-select'

import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Loader from 'Pods/Shared/Loader'
import Tooltip from 'Pods/Shared/Tooltip'

import Earnings from './Earnings/Earnings'

function EarningsContainer({
  isDataFetched,
  data,
  earningsScope,
  onSortChange,
}) {
  const sortOptions = [
    { value: 1, label: 'This month' },
    { value: 3, label: '3 months' },
    { value: 6, label: '6 months' },
    { value: 12, label: '12 months' },
    { value: 'all', label: 'Lifetime' },
  ]

  const sortOptionsForYoungAccount = [
    { value: 1, label: 'This month' },
    { value: 3, label: '3 months' },
    { value: 6, label: '6 months' },
    { value: 'all', label: 'Lifetime' },
  ]

  function renderContent() {
    if (!isDataFetched) {
      return <Loader />
    }
    if (data.length === 0) {
      return (
        <div className="empty-content u-text-center">
          <p>Ooops! Something went wrong</p>
        </div>
      )
    }
    return <Earnings data={data} />
  }

  return (
    <div className="card card--flat">
      <div className="dashboard-card dashboard-card--stats dashboard-card--earnings">
        <div className="earnings-header">
          <span className="earnings-title-group">
            Earnings
            <Tooltip
              tooltipClassName="tooltip--medium"
              id="dashboard__stats-earnings"
              content="Your model performance overview, including your latest sale and lifetime earnings on CGTrader."
            >
              <Icon type={['far', 'question-circle']} color="grey" notSpaced />
            </Tooltip>
          </span>
          {data.account_age_in_months > 6 && (
            <Select
              className="Select-new"
              id="earning-filter"
              options={
                data.account_age_in_months > 12
                  ? sortOptions
                  : sortOptionsForYoungAccount
              }
              onChange={onSortChange}
              value={earningsScope}
              searchable={false}
              clearable={false}
            />
          )}
        </div>
        {renderContent()}
      </div>
    </div>
  )
}

EarningsContainer.propTypes = {
  isDataFetched: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  earningsScope: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onSortChange: PropTypes.func.isRequired,
}

export default EarningsContainer
